<template>
	<Progress class="width-100" :percent="percent" :format="formatFunc" />
</template>

<script lang="ts">
import { computed } from 'vue';
import { Progress } from 'ant-design-vue';

export default {
	components: {
		Progress,
	},
	props: {
		count: {
			type: Number,
			required: true,
		},
		total: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const percent = computed(() => props.count / props.total * 100);
		const formatFunc = () => props.count + ' / ' + props.total;
		return {
			percent,
			formatFunc,
		};
	},
};
</script>
